import { Map } from 'immutable';
import { createReducer } from 'redux-create-reducer';

import { REDIRECT_ERROR } from '../actions';

export default createReducer(Map(), {
  [REDIRECT_ERROR]: (_, { error = Map() }) => error,
});
